<template>
  <div class="columns is-desktop">
    <div class="column">
      <config-schedule-notifications
        v-if="listNotifications"
        @addSystemNotification="showAddSystemNotifications()"
        @addNearMatchNotification="showAddNearMatchNotifications()"
        @viewNearMatchNotificationDetails="showViewNearMatchNotificationsDetails(); setScheduleId($event)"
        @viewSystemNotificationDetails="showViewSystemNotificationsDetails(); setScheduleId($event)"
        style="margin-bottom: 1rem"
        />
      <config-schedule-add-system-notifications
        v-if="addSystemNotification"
        @addSystemNotification="showAddSystemNotifications()"
        />
      <config-schedule-add-near-match-notifications
        v-if="addNearMatchNotification"
        @addNearMatchNotification="showAddNearMatchNotifications()"
        />
      <config-schedule-view-near-match-notifications-details
        v-if="viewNearMatchNotificationDetails"
        @viewNearMatchNotificationDetails="showViewNearMatchNotificationsDetails(); setScheduleId($event)"
        :schedule-data="holdScheduleData"
        />
      <config-schedule-view-system-notifications-details
        v-if="viewSystemNotificationDetails"
        @viewSystemNotificationDetails="showViewSystemNotificationsDetails(); setScheduleId($event)"
        :schedule-data="holdScheduleData"
        />
      <config-schedule-near-match-processing
        v-if="listNotifications"
        @viewNearMatchProcessingDetails="showViewNearMatchProcessingDetails()"
        />
      <config-schedule-near-match-processing-details
        v-if="viewNearMatchProcessingDetails"
        @viewNearMatchProcessingDetails="showViewNearMatchProcessingDetails()"
        />
    </div>
    <div class="column is-one-quarter">
      <quick-tips-schedule/>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
} from '@fortawesome/pro-solid-svg-icons';
import QuickTipsSchedule from '@/components/QuickTipsSchedule.vue';
import ConfigScheduleNotifications from '@/components/ConfigScheduleNotifications.vue';
import ConfigScheduleAddSystemNotifications from '@/components/ConfigScheduleAddSystemNotifications.vue';
import ConfigScheduleAddNearMatchNotifications from '@/components/ConfigScheduleAddNearMatchNotifications.vue';
import ConfigScheduleViewNearMatchNotificationsDetails from '../../components/ConfigScheduleViewNearMatchNotificationsDetails.vue';
import ConfigScheduleViewSystemNotificationsDetails from '../../components/ConfigScheduleViewSystemNotificationsDetails.vue';
import ConfigScheduleNearMatchProcessing from '../../components/ConfigScheduleNearMatchProcessing.vue';
import ConfigScheduleNearMatchProcessingDetails from '../../components/ConfigScheduleNearMatchProcessingDetails.vue';

library.add(
  faEdit,
);
export default {
  components: {
    ConfigScheduleNotifications,
    ConfigScheduleAddSystemNotifications,
    ConfigScheduleAddNearMatchNotifications,
    ConfigScheduleViewNearMatchNotificationsDetails,
    ConfigScheduleViewSystemNotificationsDetails,
    ConfigScheduleNearMatchProcessing,
    ConfigScheduleNearMatchProcessingDetails,
    QuickTipsSchedule,
  },
  data() {
    return {
      addSystemNotification: false,
      addNearMatchNotification: false,
      viewNearMatchNotificationDetails: false,
      viewSystemNotificationDetails: false,
      viewNearMatchProcessingDetails: false,
      notificationDetails: false,
      listNotifications: true,
    };
  },
  methods: {
    setScheduleId(receivedScheduleId) {
      this.holdScheduleData = receivedScheduleId;
      return this.holdScheduleData;
    },
    showAddSystemNotifications() {
      this.addSystemNotification = !this.addSystemNotification;
      this.listNotifications = !this.listNotifications;
    },
    showAddNearMatchNotifications() {
      this.addNearMatchNotification = !this.addNearMatchNotification;
      this.listNotifications = !this.listNotifications;
    },
    showViewNearMatchNotificationsDetails() {
      this.viewNearMatchNotificationDetails = !this.viewNearMatchNotificationDetails;
      this.listNotifications = !this.listNotifications;
    },
    showViewSystemNotificationsDetails() {
      this.viewSystemNotificationDetails = !this.viewSystemNotificationDetails;
      this.listNotifications = !this.listNotifications;
    },
    showViewNearMatchProcessingDetails() {
      this.viewNearMatchProcessingDetails = !this.viewNearMatchProcessingDetails;
      this.listNotifications = !this.listNotifications;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
</style>
